import * as React from 'react'
import IconButton from '@mui/material/IconButton'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { Menu, MenuItem } from '@mui/material'

export function ActionMenu({
  actions,
}: {
  actions: { title: string; action: () => void }[]
}) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  return (
    <div>
      <IconButton onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={handleClose}>
        {actions.map((a, i) => {
          return (
            <MenuItem
              key={i}
              onClick={() => {
                a.action()
                handleClose()
              }}
            >
              {a.title}
            </MenuItem>
          )
        })}
      </Menu>
    </div>
  )
}
